export default __webpack_public_path__ + "static/media/logoscmb.f5cdf6d8.jpeg";